export { default as AWSMainSection } from './AWSMainSection';
export { default as CloudMastery } from './CloudMastery';
export { default as PartnerOptimize } from './PartnerOptimize';
export { default as EffortlessAWSEvolution } from './EffortlessAWSEvolution';
export { default as FreeSubscribe } from './FreeSubscribe';
